import { render, staticRenderFns } from "./useAdd.vue?vue&type=template&id=1bc2c36c&scoped=true&"
import script from "./useAdd.vue?vue&type=script&lang=js&"
export * from "./useAdd.vue?vue&type=script&lang=js&"
import style0 from "./useAdd.vue?vue&type=style&index=0&id=1bc2c36c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc2c36c",
  null
  
)

export default component.exports